import React from 'react';
import { Card } from 'antd';
import { SkBar } from './_primitives';

const VatHeader = () => (
  <div className="flex items-start justify-between gap-3 mb-2">
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-6 h-6 rounded bg-gray-200 animate-pulse flex-shrink-0" />
      <SkBar h="h-7" w="w-72" className="max-w-full" />
    </div>
    <SkBar h="h-7" w="w-24" className="rounded-md flex-shrink-0" />
  </div>
);

const DetailRow = ({ split = false }) => (
  <div className="grid grid-cols-[1fr_2fr] sm:grid-cols-[1fr_3fr] border-b border-gray-100 last:border-b-0">
    <div className="p-4 bg-gray-50/50">
      <SkBar h="h-3" w="w-28" />
    </div>
    {split ? (
      <div className="grid grid-cols-[2fr_1fr_2fr]">
        <div className="p-4">
          <SkBar h="h-3" w="w-28" />
        </div>
        <div className="p-4 bg-gray-50/50">
          <SkBar h="h-3" w="w-20" />
        </div>
        <div className="p-4">
          <SkBar h="h-3" w="w-28" />
        </div>
      </div>
    ) : (
      <div className="p-4 flex items-center justify-between gap-3">
        <SkBar h="h-3" w="w-40" />
        <SkBar h="h-3" w="w-20" />
      </div>
    )}
  </div>
);

/**
 * VatCertificatePageLoader — matches VAT Certificate Configuration layout:
 *  outer card with icon + title + subtitle + "Expired" badge ·
 *  inner bordered card with section title + "Edit Certificate" button ·
 *  label/value grid rows (Company Name / Tax Number / Is Valid / Registration Type /
 *  Date of Issue + Expiry Date split row / Last Updated).
 */
const VatCertificatePageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    <Card className="shadow-sm" styles={{ body: { padding: 24 } }}>
      <VatHeader />
      <SkBar h="h-3" w="w-60" className="max-w-full mb-6" />

      {/* Inner bordered card */}
      <Card className="shadow-none border border-gray-200" styles={{ body: { padding: 0 } }}>
        {/* Card header row */}
        <div className="flex items-center justify-between gap-3 p-4 border-b border-gray-100">
          <SkBar h="h-5" w="w-48" />
          <SkBar h="h-9" w="w-36" className="rounded-md flex-shrink-0" />
        </div>

        {/* Detail rows */}
        <DetailRow />
        <DetailRow />
        <DetailRow />
        <DetailRow />
        <DetailRow split />
        <DetailRow />
      </Card>
    </Card>
  </div>
);

export default VatCertificatePageLoader;
